export default (theme) => ({
    root: {
        padding: '1em 1em',
        textAlign: 'center',
    },
    withGutter: {
        marginBottom: 10,
    },
    error: {
        backgroundColor: theme.custom.red,
        color: theme.palette.primary.contrastText,
    },
    success: {
        backgroundColor: theme.palette.primary.main,
        color: '#8a6d3b',
        border: '1px solid #faebcc',
        borderRadius: 6,
    },
    info: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
    },
});
